/**
 * Mirrors tenant-runtime `runtime-permissions.js` (`tr.*`).
 */
export const STAFF_PERMISSIONS = {
  staffUsersRead: 'tr.staff_users.read',
  staffUsersWrite: 'tr.staff_users.write',
  eventsRead: 'tr.events.read',
  eventsWrite: 'tr.events.write',
  catalogRead: 'tr.catalog.read',
  catalogWrite: 'tr.catalog.write',
  newsRead: 'tr.news.read',
  newsWrite: 'tr.news.write',
  mediaRead: 'tr.media.read',
  mediaWrite: 'tr.media.write',
  ordersRead: 'tr.orders.read',
  ordersWrite: 'tr.orders.write',
  paymentsRead: 'tr.payments.read',
  paymentsWrite: 'tr.payments.write',
  refundsWrite: 'tr.refunds.write',
  scanWrite: 'tr.scan.write',
  reportsRead: 'tr.reports.read',
  ticketsRead: 'tr.tickets.read',
  ticketsWrite: 'tr.tickets.write',
  financeRead: 'tr.finance.read',
  financeWrite: 'tr.finance.write',
  supportRead: 'tr.support.read',
  supportWrite: 'tr.support.write',
  auditRead: 'tr.audit.read',
  customersRead: 'tr.customers.read',
  customersWrite: 'tr.customers.write',
  settingsWrite: 'tr.settings.write',
  automationsManage: 'tr.automations.manage',
  analyticsRead: 'tr.analytics.read',
} as const

export type StaffPermission = (typeof STAFF_PERMISSIONS)[keyof typeof STAFF_PERMISSIONS]
